import {
    delay,
    put,
    select,
    takeLatest,
} from 'redux-saga/effects';

import { ADD_NOTIFICATION } from '../constants/NotificationsActions';

import { removeNotification } from '../services/Notifications';

export function* callDeleteNotification(action) {
    if (action.payload.delay <= 0) return;
    yield delay(action.payload.delay);
    const notificationsCenterDisplayed = yield select((state) => (
        state.Notifications.notificationsCenterDisplayed
    ));
    if (notificationsCenterDisplayed) return;
    yield put(removeNotification(action.payload.id));
}

export function* watchAddNotification() {
    yield takeLatest(ADD_NOTIFICATION, callDeleteNotification);
}
